var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectorioIpb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-directorio-ipb"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "directorio-ipb",
    clipPath: "url(#clip-directorio-ipb)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2106",
    "data-name": "Grupo 2106",
    transform: "translate(-10.821 -9.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_813",
    "data-name": "Trazado 813",
    d: "M0,0H124.988V124.988H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2119",
    "data-name": "Grupo 2119",
    transform: "translate(3.314 3.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_806",
    "data-name": "Trazado 806",
    d: "M6.371,3.171V0A3.181,3.181,0,0,0,3.2,3.171Zm0,82.454H3.2A3.181,3.181,0,0,0,6.371,88.8ZM22.228,0V95.14h6.343V0ZM6.371,6.343H69.8V0H6.371Zm72.94,9.514V72.94h6.343V15.857ZM69.8,82.454H6.371V88.8H69.8ZM9.543,85.626V3.171H3.2V85.626ZM79.312,72.94A9.516,9.516,0,0,1,69.8,82.454V88.8A15.852,15.852,0,0,0,85.654,72.94ZM69.8,6.343a9.516,9.516,0,0,1,9.514,9.514h6.343A15.852,15.852,0,0,0,69.8,0ZM41.256,31.713H66.626V25.371H41.256Z",
    transform: "translate(3.143)",
    fill: "#6c637b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_807",
    "data-name": "Trazado 807",
    d: "M0,0H95.14V95.14H0Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectorioIpb);
export default __webpack_public_path__ + "static/media/directorio-ipb.c7a5ee298f424db6ff9c7fd448c69f06.svg";
export { ForwardRef as ReactComponent };